import PacsInfoStore from './PacsInfoStore';
import PacsListStore from './PacsListStore';
import PacsUpsertStore from './PacsUpsertStore';

const PacsStore = {
  info: PacsInfoStore,
  list: PacsListStore,
  upsert: PacsUpsertStore,
};

export default PacsStore;
